/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-15 10:05:43
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-09 19:53:08
 */
import React, { useEffect, useState } from "react"
import styles from "./DataTable.module.css"
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons"

export interface DataTableProps {
  data?: any
  style?: React.CSSProperties
}

export const TableSimple: React.FC<DataTableProps> = ({ data, style }) => {
  let [current, setCurrent] = useState(1)

  const [size] = useState(10)

  const [total, setTotal] = useState(Math.ceil(data.length / size))

  const [startIndex, setStartIndex] = useState((current - 1) * size)

  const [endIndex, setEndIndex] = useState(current * size)

  useEffect(() => {
    setTotal(Math.ceil(data.length / size))
  }, [data?.length, size])

  useEffect(() => {
    setStartIndex((current - 1) * size)
    setEndIndex(current * size)
  }, [current, size])

  return (
    <div className={styles.content}>
      <table
        className={styles.table}
        style={style}
        onClick={() => {
          console.log("点击表格")
        }}
      >
        <thead>
          <tr>
            <th>名称</th>
            <th>预警数</th>
            <th>处置数</th>
            <th>处置占比</th>
          </tr>
        </thead>
        <tbody>
          {data.slice(startIndex, endIndex).map((v: any, i: number) => {
            return (
              <tr key={i}>
                <td style={{ textAlign: "left" }}>{v.provRuleName}</td>
                <td>{v.cautionTotal}</td>
                <td>{v.disposeTotal}</td>
                <td>
                  {v.cautionTotal === 0
                    ? "-"
                    : ((v.disposeTotal / v.cautionTotal) * 100 > 100
                        ? 100
                        : (v.disposeTotal / v.cautionTotal) * 100
                      ).toFixed(0) + "%"}
                </td>
              </tr>
            )
          })}
        </tbody>
        {total <= 1 ? (
          <></>
        ) : (
          <tfoot>
            <tr>
              <td style={{ textAlign: "center", margin: "0 auto" }} colSpan={4}>
                <span
                  onClick={() => {
                    if (current <= 1) {
                      return
                    }
                    setCurrent(current - 1)
                  }}
                >
                  <CaretDownOutlined />
                </span>
                {`${current}/${total}`}

                <span
                  onClick={() => {
                    if (current >= total) {
                      return
                    }
                    setCurrent(current + 1)
                  }}
                >
                  <CaretUpOutlined />
                </span>
              </td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  )
}
